import { File } from "../classes/File.js";
export const serverMemberHydration = {
    keyMapping: {
        _id: "id",
        joined_at: "joinedAt",
        voice_join_sound: "voiceJoinSound",
        can_publish: "canPublish",
        can_receive: "canReceive",
    },
    functions: {
        id: (member) => member._id,
        joinedAt: (member) => new Date(member.joined_at),
        nickname: (member) => member.nickname,
        avatar: (member, ctx) => new File(ctx, member.avatar),
        roles: (member) => member.roles,
        timeout: (member) => new Date(member.timeout),
        voiceJoinSound: (member) => member.voice_join_sound,
        canPublish: (member) => member.can_publish ?? true,
        canReceive: (member) => member.can_receive ?? true,
    },
    initialHydration: () => ({
        roles: [],
        canPublish: true,
        canReceive: true,
    }),
};
